import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import EditOutlined from '@ant-design/icons/EditOutlined'
import FileOutlined from '@ant-design/icons/FileOutlined'
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined'
import MoreOutlined from '@ant-design/icons/MoreOutlined'
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined'
import { Button, Dropdown, Menu, message, Modal } from 'antd'
import { inject, observer } from 'mobx-react'
import React, {
  Fragment,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { blue } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import { StatusTag } from '../../../components/Common/StatusTag'
import PageTitle from '../../../components/PageTitle'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  ELECTRONIC_DOCUMENT_STATUS,
  TYPE_STATUS,
} from '../../../constants'
import useOpenItem from '../../../hooks/useOpenItem'
import DashboardLayout from '../../../layouts/DashboardLayout/DashboardLayout'
import { HeadingButtonWrapper } from '../../../layouts/InternalDocumentDetailLayout/InternalDocumentDetailLayoutStyled'
import PopupUpdateSignDoc from '../WorkDocumentSignDocPage/PopupUpdateSignDoc/PopupUpdateSignDoc'
import CanvasDoc from './CanvasDoc'
import InternalDocumentSignDocUpdateAnnex from './workDocumentSignDocUpdateAnnex'
import PopupAddPersonInternalDocDetail from './PopupAddPersonInternalDocDetail'
import TableFileItem from './TableFileItem'

const { confirm } = Modal

const workDocumentSignDocDetailPage = props => {
  const {
    loadingAnimationStore,
    history,
    fileStore,
    match,
    electronicDocumentStore,
    signedDocumentStore,
    notificationStore,
    listHistoryLogStore,
    authenticationStore,
    location,
    onStepChange, // Thêm prop để nhận currentStep
  } = props
  const { archive_code } = match.params
  const { historyLists } = listHistoryLogStore
  const { selectedElectronicDocument } = electronicDocumentStore
  const { currentUser } = authenticationStore
  const {
    isOpen: isVisibleAddPersonWork,
    handleOpen: handleOpenAddPersonWork,
    handleClose: handleClosePopupAddPersonWork,
  } = useOpenItem()

  const {
    isOpen: isVisibleEdit,
    handleOpen: handleOpenEdit,
    handleClose: handleCloseEdit,
  } = useOpenItem()
  const [isVTXL, setVTXL] = useState(null)
  const [isFileModalVisible, setIsFileModalVisible] = useState(false)
  const [isFileModalEnnexVisible, setIsFileModalEnnexVisible] = useState(false)
  const [currentStep, setCurrentStep] = useState(0) // State để lưu currentStep

  const showFileModal = useCallback(() => {
    setIsFileModalVisible(true)
  }, [])

  const showFileModalEnnex = useCallback(() => {
    setIsFileModalEnnexVisible(true)
  }, [])

  const handleFileModalClose = useCallback(e => {
    e.stopPropagation()
    setIsFileModalVisible(false)
  }, [])

  const handleFileModalEnnexClose = useCallback(() => {
    getElectronicDocumentById()
    setIsFileModalEnnexVisible(false)
  }, [])

  const getBackUrl = useMemo(() => {
    if (location.state && location.state.from) {
      return location.state.from
    }
    if (
      document.referrer &&
      document.referrer.includes('/archiving-n-distribution')
    ) {
      return document.referrer.split(window.location.origin)[1]
    }
    return '/archiving-n-distribution'
  }, [location.state])

  const getElectronicDocumentById = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        archive_code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status).file_id
      )
    } catch (err) {
      history.push('/archiving-n-distribution')
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [archive_code, electronicDocumentStore, fileStore, history])

  useEffect(() => {
    const checkVTXL = authenticationStore.isCheckVTXL
    setVTXL(checkVTXL)
  }, [authenticationStore?.currentUser])

  useEffect(() => {
    getElectronicDocumentById()

    return () => {
      electronicDocumentStore.clearSelectedElectronicDocument()
      electronicDocumentStore.clearCommentElectronicDocumentList()
      signedDocumentStore.clearDataPopupSign()
      signedDocumentStore.clearSignatureList()
      fileStore.clearDocumentAttachment()
      notificationStore.clearNotificationType()
    }
  }, [archive_code])

  const handleDeleteElectronicDocument = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.deleteElectronicDocument(archive_code)
      history.push('/archiving-n-distribution')
      message.success('Xóa trình ký thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [archive_code, electronicDocumentStore, history])

  const showConfirm = useCallback(() => {
    confirm({
      title: 'Bạn có muốn xóa tài liệu này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteElectronicDocument()
      },
    })
  }, [handleDeleteElectronicDocument])

  const menuHandleDocument = useMemo(
    () => (
      <Menu>
        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.update__DIGITAL_DOCUMENT}>
          <Menu.Item
            key="edit"
            icon={<EditOutlined style={{ color: blue }} />}
            onClick={() => handleOpenEdit()}>
            <span style={{ color: blue }}>Chỉnh sửa</span>
          </Menu.Item>
        </AccessControlAction>

        {/* <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.annex_attachment__DIGITAL_DOCUMENT}>
          <Menu.Item
            key="file_history"
            icon={<FilePdfOutlined style={{ color: blue }} />}
            onClick={showFileModalEnnex}>
            <span style={{ color: blue }}>Phụ lục đi kèm</span>
          </Menu.Item>
        </AccessControlAction> */}

        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.delete__DIGITAL_DOCUMENT}>
          <Menu.Item danger onClick={showConfirm} icon={<DeleteOutlined />}>
            Xóa
          </Menu.Item>
        </AccessControlAction>
      </Menu>
    ),
    [handleOpenEdit, showConfirm, showFileModal, showFileModalEnnex]
  )

  // Cập nhật currentStep khi nhận từ CanvasDoc
  useEffect(() => {
    if (onStepChange) {
      onStepChange(currentStep => setCurrentStep(currentStep))
    }
  }, [onStepChange])

  return (
    <Fragment>
      <DashboardLayout>
        <Helmet>
          <title>Chi tiết Quản lý tài liệu số | Công việc {systemName}</title>
        </Helmet>
        <PageTitle
          title="Quản lý tài liệu số"
          location={props.location}
          showTitle={true}
          title={selectedElectronicDocument.title}
          status={StatusTag(
            TYPE_STATUS.ELECTRONIC_DOCUMENT,
            selectedElectronicDocument?.status,
            true
          )}
          routerGoBack={getBackUrl}>
          <HeadingButtonWrapper>
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <span className="btn-style">
                <MoreOutlined style={{ color: blue }} />
              </span>
            </Dropdown>
          </HeadingButtonWrapper>
        </PageTitle>
        <CanvasDoc
          getElectronicDocumentById={getElectronicDocumentById}
          onStepChange={step => setCurrentStep(step)} // Truyền callback để nhận currentStep
        />
      </DashboardLayout>
      <PopupAddPersonInternalDocDetail
        selectedElectronicDocument={selectedElectronicDocument}
        isVisibleAddPersonWork={isVisibleAddPersonWork}
        handleCloseAddPersonWork={handleClosePopupAddPersonWork}
      />
      <PopupUpdateSignDoc
        signDoc={selectedElectronicDocument}
        isVisiblePopupUpdateSignDoc={isVisibleEdit}
        handleClosePopupUpdateSignDoc={handleCloseEdit}
      />
      {isFileModalVisible && (
        <Modal
          title="Lịch sử File"
          visible={isFileModalVisible}
          onCancel={handleFileModalClose}
          width={1000}
          footer={[
            <Button key="back" onClick={handleFileModalClose}>
              Đóng
            </Button>,
          ]}>
          <TableFileItem historyData={historyLists} code={archive_code} />
        </Modal>
      )}
      {isFileModalEnnexVisible && (
        <InternalDocumentSignDocUpdateAnnex
          visible={isFileModalEnnexVisible}
          onClose={handleFileModalEnnexClose}
          loadingAnimationStore={loadingAnimationStore}
          selectedElectronicDocument={selectedElectronicDocument}
          getElectronicDocumentById={getElectronicDocumentById}
          currentStep={currentStep} // Truyền currentStep xuống modal
        />
      )}
    </Fragment>
  )
}

export default memo(
  inject(
    'selectUserStore',
    'departmentStore',
    'loadingAnimationStore',
    'fileStore',
    'internalDocumentStore',
    'signedDocumentStore',
    'electronicDocumentStore',
    'notificationStore',
    'listHistoryLogStore',
    'authenticationStore'
  )(observer(workDocumentSignDocDetailPage))
)
